import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e2c3bc1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w100 fh-c edit-group-component" }
const _hoisted_2 = { class: "account-area" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "box-wrap account" }
const _hoisted_5 = { class: "h100 auto" }
const _hoisted_6 = { class: "department-area" }
const _hoisted_7 = { class: "fh-c-b" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "请选择部门", -1))
const _hoisted_9 = { class: "box-wrap department fh-c" }
const _hoisted_10 = { class: "department-all h100" }
const _hoisted_11 = { class: "h100 auto" }
const _hoisted_12 = { class: "department-selected h100" }
const _hoisted_13 = { class: "has-selected" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("已选择")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("个部门（")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "勾选项将作为首选客服组，必选", -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("）")
const _hoisted_18 = {
  class: "auto",
  style: {"height":"calc(100% - 32px)"}
}
const _hoisted_19 = { style: {"padding":"10px"} }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tree = _resolveComponent("a-tree")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.showModal,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showModal) = $event)),
    title: "编辑分组",
    style: {"width":"1038px"}
  }, {
    footer: _withCtx(() => [
      (_ctx.sortGroupResult.length === 0)
        ? (_openBlock(), _createBlock(_component_a_button, {
            key: "submit",
            type: "primary",
            onClick: _ctx.handleOk,
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["onClick", "loading"]))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: "sure",
            type: "primary",
            onClick: _ctx.handleSure,
            loading: _ctx.isLoading
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          }, 8, ["onClick", "loading"]))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.sortGroupResult.length === 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "已选择" + _toDisplayString(_ctx.selectedAccounts.length) + "个账号", 1),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedAccounts, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "account-item t-line-1",
                        key: item
                      }, _toDisplayString(item.userName), 1))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", {
                    class: "cancel",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleCancelAll && _ctx.handleCancelAll(...args)))
                  }, "全部取消")
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_a_tree, {
                        checkable: "",
                        checkStrictly: "",
                        "tree-data": _ctx.treeData,
                        "field-names": _ctx.replaceFields,
                        checkedKeys: _ctx.selectedGroupIds,
                        "onUpdate:checkedKeys": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedGroupIds) = $event)),
                        onCheck: _ctx.handleCheckDefault
                      }, null, 8, ["tree-data", "field-names", "checkedKeys", "onCheck"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("a", null, _toDisplayString(_ctx.selectedGroups.length), 1),
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGroups, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "department-item",
                          key: item.id
                        }, [
                          _createVNode(_component_a_radio_group, {
                            value: _ctx.defaultServiceDeskId,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.defaultServiceDeskId) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio, {
                                value: item.id
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.name), 1)
                                ]),
                                _: 2
                              }, 1032, ["value"])
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ], 64))
          : (_openBlock(), _createBlock(_component_a_table, {
              key: 1,
              columns: _ctx.columns,
              "data-source": _ctx.sortGroupResult,
              scroll: { y: 300 },
              pagination: false
            }, {
              bodyCell: _withCtx(({ column, record }) => [
                (column.dataIndex === 'groupNames')
                  ? (_openBlock(), _createBlock(_component_a_popover, {
                      key: 0,
                      placement: "top"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_19, _toDisplayString(record.groupNames), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(record.groupNames), 1)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (column.dataIndex === 'status')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(record.status === 'success' ? '分组成功' : '分组失败'), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["columns", "data-source"]))
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}